(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cold-brew-collection-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-cold-brew-collection]');

    sections.forEach((section) => {
      const filterButtons = section.querySelectorAll('[data-filter]');
      const productCards = section.querySelectorAll('[data-product-card]');

      const applyFilter = (name) => {
        filterButtons.forEach((button) => {
          const active = button.dataset.filter === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        productCards.forEach((card) => {
          const filters = (card.dataset.filters || '').split(' ');
          const active = name === 'all' || filters.includes(name);
          card.classList.toggle('is-hidden', !active);
        });
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => applyFilter(button.dataset.filter));
      });

      const compareToggles = section.querySelectorAll('[data-compare-toggle]');
      const comparePanels = section.querySelectorAll('[data-compare-panel]');

      const activateCompare = (name) => {
        compareToggles.forEach((toggle) => {
          const active = toggle.dataset.compareToggle === name;
          toggle.classList.toggle('is-active', active);
          toggle.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        comparePanels.forEach((panel) => {
          const active = panel.dataset.comparePanel === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      compareToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => activateCompare(toggle.dataset.compareToggle));
      });

      const reveals = section.querySelectorAll('[data-reveal]');
      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      reveals.forEach((node) => observer.observe(node));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cold-brew-collection-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-cold-brew-collection]');

    sections.forEach((section) => {
      const filterButtons = section.querySelectorAll('[data-filter]');
      const productCards = section.querySelectorAll('[data-product-card]');

      const applyFilter = (name) => {
        filterButtons.forEach((button) => {
          const active = button.dataset.filter === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        productCards.forEach((card) => {
          const filters = (card.dataset.filters || '').split(' ');
          const active = name === 'all' || filters.includes(name);
          card.classList.toggle('is-hidden', !active);
        });
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => applyFilter(button.dataset.filter));
      });

      const compareToggles = section.querySelectorAll('[data-compare-toggle]');
      const comparePanels = section.querySelectorAll('[data-compare-panel]');

      const activateCompare = (name) => {
        compareToggles.forEach((toggle) => {
          const active = toggle.dataset.compareToggle === name;
          toggle.classList.toggle('is-active', active);
          toggle.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        comparePanels.forEach((panel) => {
          const active = panel.dataset.comparePanel === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      compareToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => activateCompare(toggle.dataset.compareToggle));
      });

      const reveals = section.querySelectorAll('[data-reveal]');
      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      reveals.forEach((node) => observer.observe(node));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gongfu-advisor-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {

    const seedProducts = [
      ['tray', 'Still Waters Bamboo Tea Tray', 'Tea Tray', '$58', 58, '51069138370836', '/products/still-waters-bamboo-tea-tray', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/still-waters-bamboo-tea-tray-wooden-452.webp?v=1751975291', ['starter', 'bamboo', 'tea tray', 'gongfu']],
      ['gaiwan', 'Landscape Gaiwan', 'Gaiwan', '$39', 39, '50621215670548', '/products/landscape-gaiwan', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/landscape-gaiwan-377.webp?v=1749748918', ['starter', 'porcelain', 'brewer', 'gongfu']],
      ['pitcher', 'Glass Fairness Cup', 'Tea Pitcher', '$19', 19, '50620220932372', '/products/glass-fairness-cup-gong-dao-bei', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/glass-fairness-cup-gong-dao-bei-tea-pitcher-728.webp?v=1749748900', ['starter', 'glass', 'fairness cup']],
      ['bai', '2020 Bai Mu Dan White Tea', 'White Tea', '$35', 35, '50991690613012', '/products/2020-bai-mu-dan-white-tea-sweet-floral-soft-and-lasting', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/2020-bai-mu-dan-white-tea-sweet-floral-soft-and-lasting-942.webp?v=1750087211', ['white tea', 'floral', 'gentle']],
      ['tanyang', 'Spring Beauty Tanyang Black Tea', 'Black Tea', '$15', 15, '50952547729684', '/products/spring-beauty-tanyang-gongfu-black-tea', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/spring-beauty-tanyang-gongfu-black-tea-loose-187.webp?v=1750866652', ['black tea', 'honey', 'warm']],
      ['yixing', 'Autumn Hill Yixing Teapot', 'Teapot', '$139.99', 139.99, '50573865582868', '/products/autumn-hill-yixing-teapot', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/autumn-hill-teapot-486.webp?v=1749741600', ['yixing', 'clay', 'collector']],
      ['cup', 'Aurora Jian Zhan Cup', 'Tea Cup', '$47.99', 47.99, '50484738425108', '/products/aurora-jian-zhan-tenmoku-tea-cup', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/aurora-tea-cup-925.webp?v=1749735929', ['cup', 'jian zhan', 'tenmoku']],
      ['zen-garden-cold-brew-tea', 'Teazelab Zen Garden Cold Brew Tea', 'Cold Brew Tea', '$59', 59, '52389718524180', '/products/zen-garden-cold-brew-tea', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/zen-garden-cold-brew-tea-01.webp?v=1776938007', ['cold brew', 'low effort', 'daily']],
      ['velour-rose-cold-brew-tea', 'Teazelab Velour Rose Cold Brew Tea', 'Cold Brew Tea', '$49', 49, '52389714329876', '/products/velour-rose-cold-brew-tea', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/velour-rose-cold-brew-tea-01.webp?v=1776937957', ['cold brew', 'rose', 'floral']],
      ['sunset-bliss-cold-brew-tea', 'Teazelab Sunset Bliss Cold Brew Tea', 'Cold Brew Tea', '$49', 49, '52389713740052', '/products/sunset-bliss-cold-brew-tea', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/sunset-bliss-cold-brew-tea-01.webp?v=1776937906', ['cold brew', 'fruit', 'bright']],
      ['jasmine-sunset-cold-brew-tea', 'Teazelab Jasmine Sunset Cold Brew Tea', 'Cold Brew Tea', '$49', 49, '52389713543444', '/products/jasmine-sunset-cold-brew-tea', 'https://cdn.shopify.com/s/files/1/0942/7353/6276/files/jasmine-sunset-cold-brew-tea-01.webp?v=1776937854', ['cold brew', 'jasmine', 'fresh']]
    ];

    const absoluteUrl = (url) => {
      if (url && typeof url === 'object') url = url.url || url.src || '';
      url = String(url || '');
      if (!url) return '#';
      if (url.startsWith('http')) return url;
      if (url.startsWith('/')) return url;
      return url;
    };

    const imageUrl = (src) => {
      if (src && typeof src === 'object') src = src.src || src.url || '';
      src = String(src || '');
      if (!src) return '';
      if (src.startsWith('//')) return `https:${src}`;
      if (src.startsWith('/')) return `https://tealibere.com${src}`;
      return src;
    };

    const sizedImageUrl = (src, width = 360) => {
      if (!src.includes('cdn.shopify.com')) return src;
      if (src.includes('width=')) return src;
      return `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
    };

    const priceNumber = (value) => {
      const parsed = Number(String(value || '').replace(/[^0-9.]/g, ''));
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const formatMoney = (value) => {
      if (!Number.isFinite(value) || value <= 0) return '';
      return `$${value.toFixed(Number.isInteger(value) ? 0 : 2)}`;
    };

    const classifyProduct = (product) => {
      const type = String(product.type || '').toLowerCase();
      const text = [product.title, product.key, product.handle, product.type, ...(product.tags || [])].join(' ').toLowerCase();
      const toolType = /tea tray|tea set|tea accessories|tea cup|teacup|coffee cup|tea pitcher|gaiwan|teapot|accessories|tea pets?|carving/.test(type);
      const teaType = /cold brew tea|pu['’]?er tea|green\s?tea|black tea|white tea|oolong tea|herbal tea|tea leaves|premium|^pu['’]?er$/.test(type);
      return {
        tea: teaType || (/(\bwhite tea\b|\bblack tea\b|\bgreen tea\b|\boolong\b|\bpu['’]?er\b|\bherbal\b|\bcold brew\b)/.test(text) && !toolType),
        cold: /cold brew|cold-brew|teazelab/.test(text),
        white: /white tea|bai mu dan|baimudan|shou\s?mei|silver needle|moonlight/.test(text),
        black: /black tea|tanyang|jin jun mei|dianhong|honey/.test(text),
        green: /green\s?tea|longjing|dragon well|biluochun|jasmine/.test(text),
        oolong: /oolong|dancong|tieguanyin|wuyi|rock tea/.test(text),
        puer: /pu['’]?er|puer|pu-erh|sheng|shou|ripe|raw pu|aged/.test(text),
        herbal: /herbal|rose|chrysanthemum|flower|mint|wellness/.test(text),
        tray: /tea tray|tray|drainage|bamboo/.test(text),
        gaiwan: /gaiwan|brewer|porcelain/.test(text) && !/cup|plate/.test(type),
        pitcher: /pitcher|fairness|gong dao bei|cha hai|server/.test(text),
        cup: /tea cup|teacup|cup|jian zhan|tenmoku|coffee cup/.test(text),
        teapot: /teapot|yixing|jianshui|zitao|clay pot/.test(text),
        yixing: /yixing|purple clay|zisha/.test(text),
        jianshui: /jianshui|zitao/.test(text),
        teaSet: /tea set|set|starter|gift set/.test(text),
        teaPet: /tea pet|pet|carving|ornament|symbol/.test(text),
        porcelain: /porcelain|jingdezhen|dehua|gaiwan/.test(text),
        glass: /glass|clear/.test(text),
        bamboo: /bamboo|wood|wooden/.test(text),
        glaze: /tenmoku|jian zhan|glaze|aurora/.test(text),
        gift: /gift|set|starter|bundle/.test(text),
        collector: /collector|handmade|yixing|jian zhan|tenmoku|jianshui|carving/.test(text)
      };
    };

    const roleFor = (product, facets) => {
      if (facets.cold) return 'Low-effort cold brew tea matched to bottle, fridge, and desk habits.';
      if (facets.white) return 'Gentle tea with floral sweetness and lower bitterness risk.';
      if (facets.black) return 'Warm, aromatic tea for an easy daily cup or first Gongfu session.';
      if (facets.green) return 'Fresh, clean tea for a lighter daily lift.';
      if (facets.puer) return 'Deeper tea for slower sessions and more body.';
      if (facets.oolong) return 'Aromatic tea for layered Gongfu infusions.';
      if (facets.tray) return 'Keeps rinse water and tools organized on the table.';
      if (facets.gaiwan) return 'Flexible brewer that works across many tea styles.';
      if (facets.pitcher) return 'Evens out each infusion before serving.';
      if (facets.teapot) return 'Dedicated brewer for a more personal tea lane.';
      if (facets.cup) return 'Changes cup feel, aroma, and visual rhythm.';
      if (facets.teaPet) return 'Adds table character without changing the brewing workflow.';
      return 'Matched because its category and material fit your answers.';
    };

    const enrichProduct = (product) => {
      const facets = classifyProduct(product);
      const priceValue = Number.isFinite(product.priceValue) ? product.priceValue : priceNumber(product.price);
      return {
        ...product,
        key: product.key || product.handle || product.title,
        handle: product.handle || product.key,
        url: absoluteUrl(product.url),
        image: sizedImageUrl(imageUrl(product.image)),
        price: product.price || formatMoney(priceValue),
        priceValue,
        facets,
        role: product.role || roleFor(product, facets)
      };
    };

    const normalizeShopifyProduct = (product) => {
      const variant = (product.variants || []).find((item) => item.available !== false) || (product.variants || [])[0];
      if (!variant) return null;
      const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
      const priceValue = priceNumber(variant.price);
      return enrichProduct({
        key: product.handle,
        handle: product.handle,
        title: product.title,
        price: formatMoney(priceValue),
        priceValue,
        image: (product.images || [])[0]?.src || product.image?.src || product.featured_image || '',
        url: `/products/${product.handle}`,
        variant: String(variant.id || ''),
        type: product.product_type || '',
        tags
      });
    };

    const products = Object.fromEntries(seedProducts.map(([key, title, type, price, priceValue, variant, url, image, tags]) => {
      return [key, enrichProduct({ key, title, type, price, priceValue, variant, url, image, tags })];
    }));
    let catalog = Object.values(products);
    let catalogLoaded = false;
    let catalogTotal = catalog.length;

    const loadCatalog = async () => {
      try {
        const liveProducts = [];
        for (let page = 1; page <= 8; page += 1) {
          const response = await fetch(`/products.json?limit=250&page=${page}`);
          if (!response.ok) break;
          const data = await response.json();
          const batch = data.products || [];
          liveProducts.push(...batch);
          if (batch.length < 250) break;
        }
        const normalized = liveProducts.map(normalizeShopifyProduct).filter(Boolean);
        if (normalized.length) {
          const merged = new Map();
          catalog.forEach((product) => merged.set(product.handle || product.key, product));
          normalized.forEach((product) => merged.set(product.handle || product.key, product));
          catalog = [...merged.values()];
          catalogLoaded = true;
          catalogTotal = normalized.length;
        }
      } catch (error) {
        catalogLoaded = false;
      }
    };

    const catalogReady = loadCatalog();

    const uniqueProducts = (items) => {
      const seen = new Set();
      return items.filter((item) => {
        if (!item) return false;
        const key = item.handle || item.key || item.title;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    };

    const cartFromProducts = (items) => {
      const validItems = uniqueProducts(items).filter((item) => item.variant);
      if (!validItems.length) return '/';
      return `/cart/${validItems.map((item) => `${item.variant}:1`).join(',')}`;
    };

    const paths = {
      setup: {
        label: 'Beginner setup',
        questions: [
          {
            key: 'moment',
            title: 'What is the setup supposed to solve first?',
            copy: 'A good beginner bundle is not a pile of tools. It removes one real friction from week one.',
            lesson: 'Start by naming the job. The right first pieces are the ones that make brewing repeatable.',
            choices: [
              ['first', 'I have nothing yet', 'A complete base without overbuying.'],
              ['cleanup', 'Water and leaves get messy', 'Drainage and surface control matter most.'],
              ['gift', 'It needs to feel gift-ready', 'It should look intentional and work immediately.']
            ]
          },
          {
            key: 'surface',
            title: 'Where will this ritual actually live?',
            copy: 'The table size decides whether the bundle should be compact, complete, or more ceremonial.',
            lesson: 'Footprint matters more than tradition for a first setup.',
            choices: [
              ['desk', 'Desk or small table', 'Compact, movable, easy to reset.'],
              ['dining', 'Dining table', 'Stable, prettier, still practical.'],
              ['shared', 'Shared with friends', 'Even pours and serving flow matter.']
            ]
          },
          {
            key: 'friction',
            title: 'Which part would make you stop using it?',
            copy: 'This keeps the recommendation honest: cleanup, confusing tools, or not knowing what tea to brew.',
            lesson: 'A useful bundle should remove the point where a beginner gives up.',
            choices: [
              ['water', 'Rinse water everywhere', 'Prioritize tray and easy cleanup.'],
              ['choice', 'Too many tool choices', 'Prioritize neutral flexible pieces.'],
              ['tea', 'No tea direction', 'Add a tea that teaches clearly.']
            ]
          },
          {
            key: 'bundleTaste',
            title: 'What should the first tea included in the bundle feel like?',
            copy: 'The tea add-on should match the way the tools will be used, not just look good beside them.',
            lesson: 'A starter tea should be forgiving enough to make the tools feel successful.',
            choices: [
              ['soft', 'Soft and floral', 'White tea, jasmine, and gentle cups.'],
              ['honey', 'Honeyed and warm', 'Black tea, cozy aroma, easy reward.'],
              ['cold', 'Cold or low effort', 'Cold brew for repeat drinking.'],
              ['skip', 'Tools only', 'I will choose tea later.']
            ]
          }
        ]
      },
      tea: {
        label: 'Tea finder',
        questions: [
          {
            key: 'useCase',
            title: 'What job should this tea do for you?',
            copy: 'This is the highest-signal answer. A cold bottle, a workday cup, and a slow Gongfu session need different products.',
            lesson: 'Tea choice gets smarter when it starts with use, not category names.',
            choices: [
              ['cold-desk', 'Cold bottle or desk reset', 'Low effort and repeatable.'],
              ['daily-focus', 'Daily focus cup', 'Clean lift without fuss.'],
              ['slow-session', 'Slow Gongfu session', 'Layered aroma over many infusions.'],
              ['gift-discovery', 'Discovery or gift', 'Readable flavor and low risk.']
            ]
          },
          {
            key: 'flavor',
            title: 'Which flavor direction would make you come back?',
            copy: 'Choose the memory you want, then the engine maps it to tea families and actual products.',
            lesson: 'Taste words are more useful than expert vocabulary for a first recommendation.',
            choices: [
              ['floral', 'Floral and soft', 'Jasmine, white tea, rose, gentle aroma.'],
              ['honey', 'Honeyed and warm', 'Black tea and mellow sweetness.'],
              ['fresh', 'Fresh and clean', 'Green, jasmine, light daily tea.'],
              ['deep', 'Deep and slow', 'Pu-erh, aged sweetness, clay path.'],
              ['fruit', 'Bright or fruit-leaning', 'Cold brew and herbal-style refreshment.']
            ]
          },
          {
            key: 'body',
            title: 'How much intensity should the cup carry?',
            copy: 'This prevents a recommendation that is technically good but emotionally wrong.',
            lesson: 'Body controls bitterness risk, caffeine feel, and whether the tea wants Gongfu tools.',
            choices: [
              ['gentle', 'Gentle and low-risk', 'Soft body, low bitterness.'],
              ['medium', 'Medium and expressive', 'Aromatic but still easy.'],
              ['bold', 'Bold and lingering', 'More structure and depth.']
            ]
          },
          {
            key: 'prep',
            title: 'How will you actually prepare it in week one?',
            copy: 'This final answer decides whether to recommend tea only, cold brew, or tea plus tools.',
            lesson: 'The best product is the one that survives the real habit.',
            choices: [
              ['cold', 'Cold or low effort', 'Bottle, fridge, desk.'],
              ['mug', 'Mug or small pot', 'Easy daily drinking.'],
              ['gongfu', 'Gongfu style', 'Short infusions, more aroma.'],
              ['sample', 'I want to compare', 'Several readable styles.']
            ]
          }
        ]
      },
      teaware: {
        label: 'Teaware finder',
        questions: [
          {
            key: 'job',
            title: 'What job should the next piece do?',
            copy: 'Teaware is easiest to buy by job: brew, serve, control water, improve cup feel, or add ritual.',
            lesson: 'Teaware becomes confusing when every object looks beautiful. Buy the job first, then the material.',
            choices: [
              ['brew', 'Brew better', 'Gaiwan or teapot.'],
              ['serve', 'Pour evenly', 'Pitcher or shared serving.'],
              ['water', 'Control rinse water', 'Tray and drainage.'],
              ['cup', 'Improve cup feel', 'Cup shape, glaze, heat.'],
              ['ritual', 'Add table character', 'Tea pet or collector object.']
            ]
          },
          {
            key: 'material',
            title: 'Which material are you drawn to?',
            copy: 'Material is a shortcut to how flexible the piece will be.',
            lesson: 'Porcelain and glass are neutral, so they are safer for beginners. Clay can be wonderful, but it is better when you already know the tea family you will dedicate to it.',
            choices: [
              ['porcelain', 'Porcelain', 'Clean, flexible, beginner-safe.'],
              ['glass', 'Glass', 'Visual clarity and easy matching.'],
              ['bamboo', 'Bamboo or wood warmth', 'Soft surface and table calm.'],
              ['clay', 'Yixing or Jianshui clay', 'Dedicated, personal, tea-specific.'],
              ['glaze', 'Tenmoku or expressive glaze', 'Cup-first visual pleasure.']
            ]
          },
          {
            key: 'ownership',
            title: 'How specialized should it be?',
            copy: 'This avoids recommending a collector piece when the buyer needs a practical workhorse.',
            lesson: 'A flexible piece can serve many teas. A dedicated piece should match a known habit.',
            choices: [
              ['flexible', 'Flexible daily use', 'Works with many teas.'],
              ['dedicated', 'Dedicated to one lane', 'I know the tea family.'],
              ['gift', 'Giftable and easy to understand', 'Low explanation burden.']
            ]
          },
          {
            key: 'scale',
            title: 'How much table presence do you want?',
            copy: 'This separates compact tools from permanent tea-corner objects.',
            lesson: 'Scale is a design decision as much as a shopping decision.',
            choices: [
              ['compact', 'Compact', 'Stores and resets quickly.'],
              ['shared', 'Shared sessions', 'Serve multiple cups cleanly.'],
              ['permanent', 'Permanent tea corner', 'More visual character.'],
              ['collector', 'Collector object', 'Material and story matter.']
            ]
          }
        ]
      }
    };

    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));

    const scoreProduct = (product, path, answers) => {
      const f = product.facets;
      let score = 0;
      const add = (value) => { score += value; };

      if (path === 'tea') {
        if (f.tea) add(34); else add(-85);
        if (answers.useCase === 'cold-desk' || answers.prep === 'cold') {
          if (f.cold) add(120);
          else if (f.herbal || f.green || f.white) add(18);
          else add(-48);
        }
        if (answers.useCase === 'slow-session' || answers.prep === 'gongfu') {
          if (f.puer || f.oolong || f.white || f.black) add(42);
          if (f.cold) add(-36);
        }
        if (answers.useCase === 'daily-focus') {
          if (f.green || f.black || f.cold) add(34);
        }
        if (answers.flavor === 'floral') {
          if (f.white || f.green || f.oolong || f.cold || f.herbal) add(34);
        }
        if (answers.flavor === 'honey') {
          if (f.black || f.white || f.puer) add(36);
        }
        if (answers.flavor === 'fresh') {
          if (f.green || f.cold || f.white) add(34);
        }
        if (answers.flavor === 'deep') {
          if (f.puer || f.oolong || f.black) add(42);
          if (f.cold) add(-32);
        }
        if (answers.flavor === 'fruit') {
          if (f.cold || f.herbal || f.green) add(36);
        }
        if (answers.body === 'gentle') {
          if (f.white || f.cold || f.herbal || f.green) add(18);
          if (f.puer) add(-12);
        }
        if (answers.body === 'bold') {
          if (f.puer || f.black || f.oolong) add(24);
        }
      }

      if (path === 'setup') {
        if (f.tray || f.gaiwan || f.pitcher || f.teaSet || f.teapot) add(34);
        if (answers.moment === 'first') {
          if (f.gaiwan || f.pitcher || f.tray || f.teaSet) add(28);
        }
        if (answers.moment === 'cleanup' || answers.friction === 'water') {
          if (f.tray) add(70);
          if (f.pitcher) add(20);
        }
        if (answers.moment === 'gift') {
          if (f.teaSet || f.gift || f.porcelain || f.cup) add(34);
        }
        if (answers.surface === 'shared') {
          if (f.pitcher || f.cup || f.teaSet) add(26);
        }
        if (answers.friction === 'choice') {
          if (f.gaiwan || f.pitcher || f.tray) add(28);
          if (f.yixing || f.collector) add(-12);
        }
        if (answers.bundleTaste === 'soft') {
          if (f.white || f.green || f.cold) add(34);
        }
        if (answers.bundleTaste === 'honey') {
          if (f.black || f.white) add(34);
        }
        if (answers.bundleTaste === 'cold') {
          if (f.cold) add(86);
          else if (f.tea && !f.cold) add(-18);
        }
      }

      if (path === 'teaware') {
        if (!f.tea) add(24); else add(-42);
        if (answers.job === 'brew') {
          if (f.gaiwan || f.teapot) add(72);
        }
        if (answers.job === 'serve') {
          if (f.pitcher || f.cup || f.teaSet) add(72);
        }
        if (answers.job === 'water') {
          if (f.tray) add(88);
        }
        if (answers.job === 'cup') {
          if (f.cup) add(88);
          if (f.glaze) add(22);
        }
        if (answers.job === 'ritual') {
          if (f.teaPet || f.collector || f.cup) add(64);
        }
        if (answers.material === 'porcelain') {
          if (f.porcelain || f.gaiwan) add(34);
        }
        if (answers.material === 'glass') {
          if (f.glass || f.pitcher) add(38);
        }
        if (answers.material === 'bamboo') {
          if (f.bamboo || f.tray) add(42);
        }
        if (answers.material === 'clay') {
          if (f.yixing || f.jianshui || f.teapot) add(46);
        }
        if (answers.material === 'glaze') {
          if (f.glaze || f.cup) add(46);
        }
        if (answers.ownership === 'flexible') {
          if (f.gaiwan || f.pitcher || f.tray || f.glass || f.porcelain) add(20);
          if (f.yixing) add(-16);
        }
        if (answers.ownership === 'dedicated') {
          if (f.teapot || f.yixing || f.jianshui || f.collector) add(24);
        }
        if (answers.scale === 'shared') {
          if (f.pitcher || f.cup || f.teaSet || f.tray) add(18);
        }
        if (answers.scale === 'permanent' || answers.scale === 'collector') {
          if (f.collector || f.teapot || f.teaPet || f.tray) add(20);
        }
      }

      return score;
    };

    const rankedProducts = (path, answers) => catalog
      .map((product) => ({ product, score: scoreProduct(product, path, answers) }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score || a.product.title.localeCompare(b.product.title));

    const pick = (ranked, predicate, fallback) => ranked.find((entry) => predicate(entry.product))?.product || fallback;
    const take = (ranked, predicate, limit) => ranked.filter((entry) => predicate(entry.product)).slice(0, limit).map((entry) => entry.product);

    const resultFraming = (path, answers) => {
      if (path === 'tea') {
        if (answers.useCase === 'cold-desk' || answers.prep === 'cold') {
          return {
            title: 'Cold brew, low-effort tea path',
            copy: 'Your answers point to teas that work from a bottle or fridge, so the recommendation favors Teazelab cold brew products before traditional Gongfu teas.',
            bundleTitle: 'Cold brew tasting bundle',
            bundleCopy: 'Three cold-brew singles make the habit easier to test: floral, fresh, and bright profiles instead of one blind pick.'
          };
        }
        if (answers.flavor === 'deep' || answers.useCase === 'slow-session') {
          return {
            title: 'Deeper slow-session tea path',
            copy: 'You chose depth and session time, so the engine favors Pu-erh, oolong, black tea, and support tools only when they help the brew.',
            bundleTitle: 'Slow-session bundle',
            bundleCopy: 'The bundle combines the best-matched tea with neutral tools so the recommendation is usable on day one.'
          };
        }
        return {
          title: 'Daily tea path',
          copy: 'The recommendation balances taste, body, and the way you will actually prepare the tea.',
          bundleTitle: 'Tea plus tool bundle',
          bundleCopy: 'Matched tea comes first, then only the tools that make that style easier to brew.'
        };
      }
      if (path === 'teaware') {
        return {
          title: 'Teaware path by function',
          copy: 'The result is built around the job you picked first, then refined by material, specialization, and table presence.',
          bundleTitle: 'Compatible teaware bundle',
          bundleCopy: 'The bundle groups pieces that solve the same brewing workflow instead of mixing random objects.'
        };
      }
      return {
        title: 'Starter setup path',
        copy: 'Your bundle starts from the friction you need to remove, then adds tea only when your answers ask for a ready-to-use set.',
        bundleTitle: 'Beginner setup bundle',
        bundleCopy: 'Core tools are grouped first; the tea add-on follows your taste and effort answers.'
      };
    };

    const recommendationFor = (path, answers) => {
      const ranked = rankedProducts(path, answers);
      const framing = resultFraming(path, answers);
      let items = [];
      let bundleItems = [];

      if (path === 'tea') {
        const coldMode = answers.useCase === 'cold-desk' || answers.prep === 'cold';
        if (coldMode) {
          items = take(ranked, (product) => product.facets.cold, 4);
          if (!items.length) items = Object.values(products).filter((product) => product.facets.cold);
          bundleItems = items.slice(0, 3);
        } else {
          const teas = take(ranked, (product) => product.facets.tea, 4);
          const brewer = pick(ranked, (product) => product.facets.gaiwan, products.gaiwan);
          const pitcher = pick(ranked, (product) => product.facets.pitcher, products.pitcher);
          items = uniqueProducts([...teas.slice(0, 2), brewer, pitcher]).slice(0, 4);
          bundleItems = uniqueProducts([teas[0], brewer, pitcher]).slice(0, 3);
        }
      }

      if (path === 'setup') {
        const tray = pick(ranked, (product) => product.facets.tray, products.tray);
        const brewer = pick(ranked, (product) => product.facets.gaiwan, products.gaiwan);
        const pitcher = pick(ranked, (product) => product.facets.pitcher, products.pitcher);
        const coldTea = pick(ranked, (product) => product.facets.cold, products['zen-garden-cold-brew-tea']);
        const softTea = pick(ranked, (product) => product.facets.white || product.facets.green, products.bai);
        const warmTea = pick(ranked, (product) => product.facets.black, products.tanyang);
        const tea = answers.bundleTaste === 'cold' ? coldTea : answers.bundleTaste === 'honey' ? warmTea : answers.bundleTaste === 'soft' ? softTea : null;
        items = uniqueProducts([tray, brewer, pitcher, tea]).slice(0, 4);
        bundleItems = items;
      }

      if (path === 'teaware') {
        items = take(ranked, (product) => !product.facets.tea, 4);
        if (!items.length) items = [products.gaiwan, products.pitcher, products.tray];
        const supportTea = pick(ranked, (product) => product.facets.black || product.facets.white || product.facets.cold, products.tanyang);
        bundleItems = uniqueProducts([items[0], items[1], supportTea]).slice(0, 3);
      }

      items = uniqueProducts(items).filter(Boolean).slice(0, 4);
      if (!items.length) items = Object.values(products).slice(0, 3);
      bundleItems = uniqueProducts(bundleItems.length ? bundleItems : items.slice(0, 3)).filter(Boolean);
      const alternates = ranked
        .map((entry) => entry.product)
        .filter((product) => !items.some((item) => (item.handle || item.key) === (product.handle || product.key)))
        .slice(0, 5);
      const matchedCount = ranked.filter((entry) => entry.score >= 30).length;

      return {
        ...framing,
        items,
        bundleItems,
        alternates,
        offerTitle: 'Bundle idea',
        offerCopy: framing.bundleCopy,
        cta: cartFromProducts(bundleItems),
        ctaLabel: 'Build this bundle',
        secondary: items[0]?.url || '/',
        catalogNote: `${catalogLoaded ? 'Live catalog' : 'Fallback catalog'}: matched ${matchedCount} relevant products from ${catalogTotal} products.`,
        cartNote: 'No coupon is attached to this cart link; review the items before checkout.'
      };
    };

    const bundleForProduct = (product, result) => {
      const bundle = uniqueProducts([product, ...result.bundleItems]).slice(0, 4);
      return [
        'Add compatible bundle',
        `${bundle.length} matched item${bundle.length > 1 ? 's' : ''} ready for the cart.`,
        cartFromProducts(bundle)
      ];
    };

    const bundleSummary = (result) => {
      const items = result.bundleItems.length ? result.bundleItems : result.items.slice(0, 3);
      const subtotal = items.reduce((sum, item) => sum + (item.priceValue || priceNumber(item.price)), 0);
      return {
        items,
        subtotal,
        url: cartFromProducts(items)
      };
    };

    document.querySelectorAll('[data-gongfu-advisor]').forEach((root) => {
      const content = root.querySelector('[data-advisor-content]');
      const lesson = root.querySelector('[data-advisor-lesson]');
      const progress = root.querySelector('[data-advisor-progress]');
      const tabs = root.querySelectorAll('[data-advisor-path]');
      const visual = root.querySelector('[data-advisor-visual]');
      const sceneMarkers = root.querySelectorAll('[data-advisor-marker]');
      const capture = root.querySelector('[data-advisor-capture]');
      const tagsInput = root.querySelector('[data-advisor-tags]');
      const params = new URLSearchParams(window.location.search);
      let path = params.get('path') || root.dataset.defaultPath || 'setup';
      if (!paths[path]) path = 'setup';
      let step = 0;
      let answers = {};
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const animateIn = () => {
        if (prefersReducedMotion) return;
        const stage = content.querySelector('.gongfu-advisor__stage');
        const staggerItems = content.querySelectorAll('.gongfu-advisor__choice, .gongfu-advisor__product-card, .gongfu-advisor__offer, .gongfu-advisor__bundle-thumb, .gongfu-advisor__match-chip');
        if (stage) {
          stage.animate(
            [
              { opacity: 0, transform: 'translateY(18px) scale(0.985)', filter: 'blur(8px)' },
              { opacity: 1, transform: 'translateY(0) scale(1)', filter: 'blur(0)' }
            ],
            { duration: 430, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
        }
        staggerItems.forEach((item, index) => {
          item.animate(
            [
              { opacity: 0, transform: 'translateY(18px) scale(0.985)' },
              { opacity: 1, transform: 'translateY(0) scale(1)' }
            ],
            { duration: 360, delay: 70 + index * 58, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
        });
      };

      const swapContent = (html) => {
        const current = content.firstElementChild;
        if (!current || prefersReducedMotion) {
          content.innerHTML = html;
          animateIn();
          return;
        }
        const out = current.animate(
          [
            { opacity: 1, transform: 'translateY(0) scale(1)', filter: 'blur(0)' },
            { opacity: 0, transform: 'translateY(-18px) scale(0.985)', filter: 'blur(8px)' }
          ],
          { duration: 210, easing: 'cubic-bezier(.4, 0, 1, 1)' }
        );
        out.onfinish = () => {
          content.innerHTML = html;
          animateIn();
        };
      };

      const updateTabs = () => {
        tabs.forEach((tab) => {
          const active = tab.dataset.advisorPath === path;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (visual) visual.dataset.activePath = path;
        sceneMarkers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.advisorMarker === path);
        });
      };

      const updateProgress = () => {
        if (!progress) return;
        const total = paths[path].questions.length;
        progress.innerHTML = Array.from({ length: total }, (_, index) => {
          const className = index < step ? 'is-done' : index === step ? 'is-active' : '';
          return `<span class="${className}"></span>`;
        }).join('');
      };

      const renderQuestion = () => {
        const config = paths[path];
        const question = config.questions[step];
        updateTabs();
        updateProgress();
        if (capture) capture.hidden = true;
        if (lesson) lesson.textContent = question.lesson;

        swapContent(`
          <div class="gongfu-advisor__question gongfu-advisor__stage">
            <p class="gongfu-advisor__question-label">${escapeHtml(config.label)} - step ${step + 1} of ${config.questions.length}</p>
            <h2 class="gongfu-advisor__question-title">${escapeHtml(question.title)}</h2>
            <p class="gongfu-advisor__question-copy">${escapeHtml(question.copy)}</p>
            <div class="gongfu-advisor__choices">
              ${question.choices.map((choice, index) => {
                const selected = answers[question.key] === choice[0] ? ' is-selected' : '';
                return `
                  <button class="gongfu-advisor__choice${selected}" type="button" data-choice-index="${index + 1}" data-answer-key="${escapeHtml(question.key)}" data-answer-value="${escapeHtml(choice[0])}">
                    <span class="gongfu-advisor__choice-text">
                      <strong>${escapeHtml(choice[1])}</strong>
                      <span>${escapeHtml(choice[2])}</span>
                    </span>
                  </button>
                `;
              }).join('')}
            </div>
            <div class="gongfu-advisor__nav">
              <button type="button" data-advisor-back ${step === 0 ? 'disabled' : ''}>Back</button>
              <button type="button" data-advisor-next ${answers[question.key] ? '' : 'disabled'}>${step === config.questions.length - 1 ? 'See recommendation' : 'Continue'}</button>
            </div>
          </div>
        `);
      };

      const renderResult = async () => {
        if (!catalogLoaded) {
          await Promise.race([
            catalogReady,
            new Promise((resolve) => window.setTimeout(resolve, 3000))
          ]);
        }
        const result = recommendationFor(path, answers);
        const bundle = bundleSummary(result);
        updateTabs();
        if (progress) {
          const total = paths[path].questions.length;
          progress.innerHTML = Array.from({ length: total }, () => '<span class="is-done"></span>').join('');
        }
        if (lesson) {
          lesson.textContent = 'The recommendation is not final. You can loop back, change one answer, and the bundle will reshape around the new job, taste, or material.';
        }
        if (capture) capture.hidden = false;
        if (tagsInput) {
          const answerTags = Object.entries(answers).map(([key, value]) => `gongfu-${key}-${value}`);
          tagsInput.value = ['newsletter', 'gongfu-advisor', `gongfu-path-${path}`, ...answerTags].join(', ');
        }
        swapContent(`
          <div class="gongfu-advisor__result gongfu-advisor__stage">
            <div class="gongfu-advisor__result-head">
              <p class="gongfu-advisor__question-label">Your recommendation</p>
              <h2>${escapeHtml(result.title)}</h2>
              <p>${escapeHtml(result.copy)}</p>
            </div>
            <div class="gongfu-advisor__result-grid">
              ${result.items.slice(0, 4).map((product) => {
                const productBundle = bundleForProduct(product, result);
                return `
                  <div class="gongfu-advisor__product-card">
                    <a href="${product.url}">
                      <img src="${product.image}" alt="${escapeHtml(product.title)}" loading="eager" width="300" height="300">
                    </a>
                    <div>
                      <a href="${product.url}"><strong>${escapeHtml(product.title)}</strong></a>
                      <span>${escapeHtml(product.role)}</span>
                      <span class="gongfu-advisor__product-price">${escapeHtml(product.price)}</span>
                    </div>
                    <div class="gongfu-advisor__buy-together">
                      <a href="${productBundle[2]}">${escapeHtml(productBundle[0])}</a>
                      <small>${escapeHtml(productBundle[1])}</small>
                    </div>
                  </div>
                `;
              }).join('')}
            </div>
            <div class="gongfu-advisor__offer">
              <div class="gongfu-advisor__offer-head">
                <div>
                  <strong>${escapeHtml(result.offerTitle)}: ${escapeHtml(result.bundleTitle)}</strong>
                  <p>${escapeHtml(result.offerCopy)}</p>
                </div>
                <span class="gongfu-advisor__discount-pill">Starter cart</span>
              </div>
              <div class="gongfu-advisor__bundle-visual">
                <div class="gongfu-advisor__bundle-thumbs" aria-label="Bundle products">
                  ${bundle.items.map((item, index) => `
                    ${index > 0 ? '<span class="gongfu-advisor__bundle-plus">+</span>' : ''}
                    <a class="gongfu-advisor__bundle-thumb" href="${item.url}" title="${escapeHtml(item.title)}">
                      <img src="${item.image}" alt="" loading="eager" width="160" height="160">
                    </a>
                  `).join('')}
                </div>
                <div class="gongfu-advisor__bundle-meta">
                  <strong>${escapeHtml(bundle.items.map((item) => item.title).join(' + '))}</strong>
                  <div class="gongfu-advisor__bundle-price-row">
                    <span class="gongfu-advisor__bundle-total">Estimated cart ${escapeHtml(formatMoney(bundle.subtotal))}</span>
                  </div>
                  <p>${escapeHtml(result.cartNote)}</p>
                </div>
              </div>
              <p class="gongfu-advisor__catalog-note">${escapeHtml(result.catalogNote)}</p>
              ${result.alternates.length ? `
                <div class="gongfu-advisor__also-matched">
                  <strong>Also reasonable from your answers</strong>
                  <div class="gongfu-advisor__match-strip">
                    ${result.alternates.map((item) => `
                      <a class="gongfu-advisor__match-chip" href="${item.url}">
                        <img src="${item.image}" alt="" loading="lazy" width="76" height="76">
                        <span>${escapeHtml(item.title)}</span>
                      </a>
                    `).join('')}
                  </div>
                </div>
              ` : ''}
              <div class="gongfu-advisor__result-actions">
                <a class="gongfu-advisor__result-action" href="${bundle.url}">${escapeHtml(result.ctaLabel)}</a>
                <a class="gongfu-advisor__result-secondary" href="${result.secondary}">View single product path</a>
              </div>
            </div>
            <div class="gongfu-advisor__loop">
              <button type="button" data-advisor-refine>Refine answers</button>
              <button type="button" data-advisor-reset>Try another path</button>
            </div>
          </div>
        `);
      };

      const goNext = async () => {
        const total = paths[path].questions.length;
        if (step < total - 1) {
          step += 1;
          renderQuestion();
        } else {
          await renderResult();
        }
      };

      const setPath = (nextPath) => {
        if (!paths[nextPath]) return;
        path = nextPath;
        step = 0;
        answers = {};
        renderQuestion();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => setPath(tab.dataset.advisorPath));
      });

      content.addEventListener('click', (event) => {
        const answerButton = event.target.closest('[data-answer-key]');
        if (answerButton) {
          answerButton.classList.add('is-selected');
          answers[answerButton.dataset.answerKey] = answerButton.dataset.answerValue;
          window.setTimeout(goNext, prefersReducedMotion ? 0 : 140);
          return;
        }
        if (event.target.closest('[data-advisor-back]')) {
          step = Math.max(0, step - 1);
          renderQuestion();
          return;
        }
        if (event.target.closest('[data-advisor-next]')) {
          goNext();
          return;
        }
        if (event.target.closest('[data-advisor-refine]')) {
          step = Math.max(0, paths[path].questions.length - 1);
          renderQuestion();
          return;
        }
        if (event.target.closest('[data-advisor-reset]')) {
          const order = ['setup', 'tea', 'teaware'];
          const next = order[(order.indexOf(path) + 1) % order.length];
          setPath(next);
        }
      });

      renderQuestion();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["small-gongfu-setup-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const content = {
      setup: {
        title: 'Starter setup',
        body: 'A tray, gaiwan, and fairness pitcher: the practical first table for a beginner.'
      },
      tea: {
        title: 'Choose tea',
        body: 'Start with taste: floral, honeyed, refreshing, or deep. The advisor turns that into a first tea.'
      },
      teaware: {
        title: 'Choose teaware',
        body: 'Pick the job first: brew, serve, control water, or improve the cup feel.'
      }
    };

    document.querySelectorAll('[data-gongfu-gateway]').forEach((root) => {
      const banner = root.querySelector('.gongfu-journey__banner');
      const buttons = root.querySelectorAll('[data-gateway-path]');
      const start = root.querySelector('[data-gateway-start]');
      const hintTitle = root.querySelector('[data-gateway-hint-title]');
      const hintCopy = root.querySelector('[data-gateway-hint-copy]');
      const advisorLink = root.dataset.advisorLink || '/pages/chinese-tea-starter-gift-sets?view=sales-sprint-live';
      const pathLinks = {
        setup: root.dataset.setupLink || advisorLink,
        tea: root.dataset.teaLink || advisorLink,
        teaware: root.dataset.teawareLink || advisorLink
      };

      const setPath = (path) => {
        const nextPath = content[path] ? path : 'setup';
        if (banner) banner.dataset.activePath = nextPath;
        buttons.forEach((button) => {
          const active = button.dataset.gatewayPath === nextPath;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (start) start.href = pathLinks[nextPath] || advisorLink;
        if (hintTitle) hintTitle.textContent = content[nextPath].title;
        if (hintCopy) hintCopy.textContent = content[nextPath].body;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => setPath(button.dataset.gatewayPath));
      });

      setPath('setup');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
